import React, { useEffect, useState } from 'react';
import {
    TextField, Paper, Button, Typography, Select, MenuItem,
    InputLabel, FormControl, Card, Divider, CardContent,
    CircularProgress, Grid, Modal, CardHeader, IconButton,
    TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Autocomplete, Checkbox, FormGroup, FormControlLabel
} from '@mui/material';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import apiService from '../../services/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function MappingList() {
    const s_token = localStorage.getItem('access_token');
    const loginObjStr = localStorage.getItem('loginObj');
    const [loading, setLoading] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const loginObj = JSON.parse(loginObjStr);
    const userCode = loginObj?.userSession?.userCode || null;
    const location = useLocation();
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(true);
    const itemsPerPage = 10;

    const [addMapp, setAddMapp] = useState(false);
    const [eclinicData, setEclinicData] = useState([]);
    const [searchFilters, setSearchFilters] = useState({});
const [mobiUsers, setMobiUsers] = useState([]);
    const [phelUserList, setPhelUserList] = useState([]);
    const [collectionList, setCollectionList] = useState([]);
    const [tableList, setTableList] = useState([]);

    const toValue = location.state?.toValue;

    const getPageTitle = () => {
        if (toValue === 'CHE') return 'Eclinic';
        if (toValue === 'CC') return 'Collection Center';
        if (toValue === 'PH') return 'Phlebo';
        return '';
    };

    const isEclinic = toValue === 'CHE';
    const isCollectionCenter = toValue === 'CC';
    const isPhlebo = toValue === 'PH';

    const getHeaderColumnText = () => {
        if (isEclinic) return 'Eclinic';
        if (isCollectionCenter) return 'Collection Center';
        if (isPhlebo) return 'User';
        return '';
    };

    const handleModal = () => {
        setAddMapp(!addMapp);
        moblabUserList();
    };

    const getCCList = async () => {
        const res1 = await apiService.getCCList();
        setCollectionList(res1?.data?.successList || []);
    };

    const getEclinics = async (e = 'bam') => {
        const response = await axios.get(
            `${process.env.REACT_APP_COMMON_URL}EclinicAddress/list?eclinicName=${e}`,
            { headers: { 'Authorization': `Bearer ${s_token}` } }
        );
        if (response?.data?.data) {
            setEclinicData(response.data.data);
        }
    };

    const moblabUserList = async () => {
        const res1 = await apiService.getmobiUserList();
        setMobiUsers(res1?.data?.user_details || []);
    };

    const getphelboUserList = async (e = '') => {
        const payload = {
            name: e
        };
        const res1 = await apiService.getphelboUserList(payload);
        setPhelUserList(res1?.data?.successList || []);
    };

    const gettableList = async (pageNo = 1) => {
        setLoading(true);
        try {
            let type = 'SMP';
            if (isEclinic) type = 'C';
            if (isCollectionCenter) type = 'CC';

            let payload = {
                type,
                pageNumber: pageNo,
                pageSize: itemsPerPage
            };

            Object.keys(payload).forEach(key => {
                if (payload[key] === undefined) {
                    delete payload[key];
                }
            });

            const res1 = await apiService.getmappingList(payload);

            if (res1?.data?.successList) {
                setTableList(res1.data.successList);
                setCurrentPage(pageNo);
                setHasNextPage(res1.data.successList.length >= itemsPerPage);
            } else {
                setTableList([]);
                setHasNextPage(false);
            }
        } catch (error) {
            console.error('API request error:', error);
            setTableList([]);
            setHasNextPage(false);
        }
        setLoading(false);
    };

    const validateFilters = () => {
        if (isEclinic && !searchFilters?.CHEId) {
            toast.error('Please select Eclinic.');
            return false;
        }
        if (isCollectionCenter && !searchFilters?.ccCode) {
            toast.error('Please select Collection Center.');
            return false;
        }
        if (isPhlebo && !searchFilters?.phelCode) {
            toast.error('Please select Phlebo User.');
            return false;
        }
        if (!searchFilters?.mobiId) {
            toast.error('Please select Mobilab User.');
            return false;
        }
        return true;
    };

    const saveMapping = async () => {
        if (!validateFilters()) return;

        setLoading(true);
        let hospitalId = null;
        if (isEclinic) {
            hospitalId = searchFilters?.CHEId;
        } else if (isCollectionCenter) {
            hospitalId = searchFilters?.ccCode;
        }

        let type = 'SMP';
        if (isEclinic) type = 'C';
        if (isCollectionCenter) type = 'CC';

        const payload = {
            hospitalId: hospitalId,
            userId: searchFilters?.phelCode ?? null,
            mobilabId: searchFilters?.mobiId,
            type,
            status: 1,
            createdBy: userCode,
            updatedBy: userCode,
            cbcDevice: searchFilters?.cbcDevice || false,
            mobilabDevice: searchFilters?.mobilabDevice || false
        };

        const res1 = await apiService.saveMapping(payload);
        setLoading(false);

        if (res1?.data?.responseCode === '200') {
            toast.success(res1?.data?.reponseMessage);
            gettableList(1);
            setMobiUsers([]);
            setEclinicData([]);
            setSearchFilters({});
            handleModal();
        } else {
            toast.error(res1?.data?.reponseMessage);
        }
    };

    const deleteMapping = async () => {
        if (selectedIndex === null && selectedIndex !== 0) {
            toast.error('Please select which mapping you want to delete');
            return;
        }

        setLoading(true);
        const payload = {
            id: tableList[selectedIndex]?.id
        };
        const res1 = await apiService.deleteMapping(payload);
        setLoading(false);

        if (res1?.data?.responseCode === '200') {
            toast.success(res1?.data?.reponseMessage);
            setSelectedIndex(null);
            gettableList(currentPage);
        } else {
            toast.error(res1?.data?.reponseMessage);
        }
    };

    const handleNextPage = () => {
        const nextPage = currentPage + 1;
        gettableList(nextPage);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            const prevPage = currentPage - 1;
            gettableList(prevPage);
        }
    };

    const handlePageClick = (pageNumber) => {
        gettableList(pageNumber);
    };

    useEffect(() => {
        const init = async () => {
            if (toValue) {
                await gettableList(1);

                setAddMapp(false);
                setSearchFilters({});
                setSelectedIndex(null);
                setMobiUsers([]);
                setEclinicData([]);

                if (isEclinic) {
                    await getEclinics();
                } else if (isCollectionCenter) {
                    await getCCList();
                } else if (isPhlebo) {
                    await getphelboUserList();
                }

                await moblabUserList();
            } else {
                navigate('/');
            }
        };

        init();
    }, [toValue]);

    const getEclinicOptionValue = () => {
        return eclinicData?.find((lab) => lab.eclinicCode === searchFilters?.CHEId) || null;
    };

    const getPhleboOptionValue = () => {
        return phelUserList?.find((user) => user.userCode === searchFilters?.phelCode) || null;
    };

    const getCollectionOptionValue = () => {
        return collectionList?.find((lab) => lab.labCode === searchFilters?.ccCode) || null;
    };

    const renderAutocompleteField = () => {
        if (isEclinic) {
            return (
                <Autocomplete
                    options={eclinicData}
                    getOptionLabel={(option) => option?.eclinicName || ''}
                    onChange={(event, newValue) =>
                        setSearchFilters({
                            ...searchFilters,
                            CHEId: newValue?.eclinicCode || '',
                            labPartner: ''
                        })
                    }
                    onInputChange={(event, value) => getEclinics(value)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Eclinics"
                            variant="outlined"
                            size="small"
                            placeholder="Filter Eclinics"
                        />
                    )}
                    value={getEclinicOptionValue()}
                    isOptionEqualToValue={(option, value) => option?.eclinicCode === value?.eclinicCode}
                />
            );
        }

        if (isCollectionCenter) {
            return (
                <Autocomplete
                    options={collectionList}
                    getOptionLabel={(option) => option?.labName}
                    isOptionEqualToValue={(option, value) => option?.labCode === value?.labCode}
                    value={getCollectionOptionValue()}
                    onChange={(event, newValue) =>
                        setSearchFilters({ ...searchFilters, ccCode: newValue?.labCode || '', labPartner: '' })
                    }
                    renderOption={(props, option) => (
                        <li {...props} key={option?.labCode}>
                            {option?.labName}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField {...params} label="Collection Center" variant="outlined" size="small" placeholder="Filter labs" />
                    )}
                />
            );
        }

        if (isPhlebo) {
            return (
                <Autocomplete
                    options={phelUserList}
                    getOptionLabel={(option) => option?.name || ''}
                    onChange={(event, newValue) =>
                        setSearchFilters({
                            ...searchFilters,
                            phelCode: newValue?.userCode || '',
                            labPartner: ''
                        })
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Phlebotomist"
                            variant="outlined"
                            size="small"
                            placeholder="Filter users"
                        />
                    )}
                    value={getPhleboOptionValue()}
                    isOptionEqualToValue={(option, value) => option?.userCode === value?.userCode}
                />
            );
        }

        return null;
    };

    const getRowKey = (order) => {
        return order?.id || order?.hospitalId || order?.userId;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '2rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 64, zIndex: 10, backgroundColor: '#fff', paddingTop: '0.5rem', paddingBottom: '0.5rem', marginTop: '1rem', marginBottom: '1rem' }}>
                <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: '600' }}>
                    Mapping {getPageTitle()} List
                </Typography>
                {loading && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center">
                        <CircularProgress color="secondary" />
                    </div>
                )}
                <div className='flex gap-2 mr-10'>
                    <Button onClick={handleModal}><span className='font-extrabold'>+Add</span></Button>
                    <button onClick={deleteMapping} className='font-bold text-red-600 p-9'>Delete</button>
                </div>
            </div>

            <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 280px)', minHeight: 350, overflow: 'auto' }}>
                <Table stickyHeader>
                    <TableHead sx={{ bgcolor: '#f4f6f9', '& .MuiTableCell-root': { bgcolor: '#f4f6f9', fontWeight: 'bold' } }}>
                        <TableRow>
                            <TableCell sx={{ bgcolor: '#f4f6f9' }}></TableCell>
                            <TableCell sx={{ bgcolor: '#f4f6f9' }}>{getHeaderColumnText()} Code</TableCell>
                            <TableCell sx={{ bgcolor: '#f4f6f9' }}>{getHeaderColumnText()} Name</TableCell>
                            <TableCell sx={{ bgcolor: '#f4f6f9' }}>Mobilab Name</TableCell>
                            {isEclinic && (
                                <>
                                    <TableCell sx={{ bgcolor: '#f4f6f9' }}>Mobilab Device</TableCell>
                                    <TableCell sx={{ bgcolor: '#f4f6f9' }}>CBC Device</TableCell>
                                </>
                            )}
                            <TableCell sx={{ bgcolor: '#f4f6f9' }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableList.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={isEclinic ? 7 : 5} align="center">
                                    No Data
                                </TableCell>
                            </TableRow>
                        ) : (
                            tableList.map((order, index) => (
                                <TableRow key={getRowKey(order)}>
                                    <TableCell>
                                        <input
                                            type="radio"
                                            name="selectedRow"
                                            checked={selectedIndex === index}
                                            onChange={() => setSelectedIndex(index)}
                                        />
                                    </TableCell>
                                    {!isPhlebo && <TableCell>{order?.hospitalId}</TableCell>}
                                    {isPhlebo && <TableCell>{order?.userId}</TableCell>}
                                    {!isPhlebo && <TableCell>{order?.hospitalName}</TableCell>}
                                    {isPhlebo && <TableCell>{order?.smName}</TableCell>}
                                    <TableCell>{order?.name}</TableCell>
                                    {isEclinic && (
                                        <>
                                            <TableCell>
                                                <Typography
                                                    style={{ fontWeight: 'bold', color: order?.mobilabDevice ? 'green' : 'red' }}
                                                >
                                                    {order?.mobilabDevice ? '✔' : '✖'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography
                                                    style={{ fontWeight: 'bold', color: order?.cbcDevice ? 'green' : 'red' }}
                                                >
                                                    {order?.cbcDevice ? '✔' : '✖'}
                                                </Typography>
                                            </TableCell>
                                        </>
                                    )}
                                    <TableCell>
                                        <span className={order?.status === 1 ? 'text-green-500' : 'text-red-500'}>
                                            {order?.status === 1 ? 'Active' : 'Inactive'}
                                        </span>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <div className="flex justify-center items-center mt-4 mb-8 gap-2">
                <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="px-4 py-2 border rounded disabled:opacity-50 hover:bg-gray-50 transition-colors"
                >
                    Previous
                </button>

                <button
                    onClick={() => handlePageClick(1)}
                    className={`px-4 py-2 border rounded ${currentPage === 1 ? 'bg-blue-100 border-blue-300' : 'hover:bg-gray-50'} transition-colors`}
                >
                    1
                </button>

                {currentPage > 1 && (
                    <button
                        onClick={() => handlePageClick(currentPage)}
                        className="px-4 py-2 border rounded bg-blue-100 border-blue-300"
                    >
                        {currentPage}
                    </button>
                )}

                <button
                    onClick={handleNextPage}
                    disabled={!hasNextPage}
                    className="px-4 py-2 border rounded disabled:opacity-50 hover:bg-gray-50 transition-colors"
                >
                    Next
                </button>
            </div>

            <Modal open={addMapp}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', overflowY: 'auto' }}>
                    <Card style={{ width: '80vw', maxWidth: '1200px', borderRadius: '8px' }}>
                        <CardHeader
                            title={
                                <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    Add Mapping
                                </Typography>
                            }
                            action={<IconButton onClick={handleModal}><CloseIcon /></IconButton>}
                            style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}
                        />
                        <Divider />
                        <CardContent>
                            <Paper elevation={2} style={{ padding: '16px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        {renderAutocompleteField()}
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <InputLabel id="mobilelab-user-label">MobiLab Users*</InputLabel>
                                            <Select
                                                labelId="mobilelab-user-label"
                                                id="mobilelab-user-select"
                                                value={searchFilters?.mobiId || ''}
                                                label="MobileLab Users*"
                                                onChange={(e) =>
                                                    setSearchFilters({ ...searchFilters, mobiId: e.target.value })
                                                }
                                            >
                                                {Array.isArray(mobiUsers) &&
                                                    mobiUsers.map((element) => (
                                                        <MenuItem key={element?.mobilabId} value={element?.mobilabId}>
                                                            {element?.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {isEclinic && (
                                    <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                        <FormGroup row>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={searchFilters?.mobilabDevice || false}
                                                        onChange={(e) =>
                                                            setSearchFilters({
                                                                ...searchFilters,
                                                                mobilabDevice: e.target.checked,
                                                            })
                                                        }
                                                        name="mobilabDevice"
                                                        color="primary"
                                                    />
                                                }
                                                label="Mobilab Device"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={searchFilters?.cbcDevice || false}
                                                        onChange={(e) =>
                                                            setSearchFilters({
                                                                ...searchFilters,
                                                                cbcDevice: e.target.checked,
                                                            })
                                                        }
                                                        name="cbcDevice"
                                                        color="primary"
                                                    />
                                                }
                                                label="CBC Device"
                                            />
                                        </FormGroup>
                                    </Grid>
                                )}
                            </Paper>
                        </CardContent>
                        <CardContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" onClick={saveMapping}>Save</Button>
                                <Button variant="outlined" color="secondary" style={{ marginLeft: '10px' }} onClick={handleModal}>Cancel</Button>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </Modal>
        </div>
    );
}

MappingList.propTypes = {
    onClose: PropTypes.func,
};

MappingList.defaultProps = {
    onClose: () => { },
};

export default MappingList;